import { z } from 'zod';
import { UserType } from '../user-types';
import { PipelineStageConfigSchema } from '../view-system/view-response.schema';
import { DateOrIsoStringSchema } from './date-or-iso';
import { GongClientCallSummarySchema, GongClientCallWithTranscriptSchema } from './gong';

export const AdminArtifactTypesResponseSchema = z.object({
  artifactTypes: z.array(z.object({ slug: z.string(), label: z.string() })),
});

export const AdminFixtureTeamResponseSchema = z.object({
  team: z.array(
    z.object({
      email: z.string(),
      slackId: z.string().nullable(),
      label: z.string(),
      found: z.boolean(),
    }),
  ),
});

export const AdminFixtureOpportunityResponseSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  stage: z.string().nullable(),
  amount: z.number().nullable(),
  closeDate: z.string().nullable(),
  nextStep: z.string().nullable(),
  probability: z.number().nullable(),
  description: z.string().nullable(),
  accountId: z.string().nullable(),
  accountName: z.string().nullable(),
});

export const AdminGongConfigResponseSchema = z.object({
  configured: z.boolean(),
  envVars: z.object({ hasAccessKey: z.boolean(), hasSecretKey: z.boolean() }),
});

export const AdminGongCallsResponseSchema = z.object({
  calls: z.array(GongClientCallSummarySchema),
  count: z.number(),
});

export const AdminGongTranscriptResponseSchema = GongClientCallWithTranscriptSchema.extend({ callId: z.string() });

export const SalesforceReprocessDryRunResponseSchema = z.object({
  dryRun: z.literal(true),
  totalMatching: z.number(),
  limit: z.number(),
  wouldProcess: z.number(),
  breakdown: z.array(z.object({ prefix: z.string(), count: z.number() })),
});

export const SalesforceReprocessEmptyResponseSchema = z.object({
  ok: z.literal(true),
  message: z.string(),
  totalMatching: z.number(),
  processed: z.number(),
});

export const SalesforceReprocessResultResponseSchema = z.object({
  ok: z.literal(true),
  totalMatching: z.number(),
  processed: z.number(),
  results: z.object({
    success: z.number(),
    not_found: z.number(),
    pending: z.number(),
    failed: z.number(),
  }),
});

export const SalesforceResolutionStatsResponseSchema = z.object({
  stats: z.record(z.string(), z.record(z.string(), z.number())),
});

export const AdminPipelineStagesResponseSchema = z.object({
  stages: z.array(PipelineStageConfigSchema),
  syncedAt: DateOrIsoStringSchema.nullable(),
});

export const AdminProductionUsersResponseSchema = z.object({
  users: z.array(
    z.object({
      slackUserId: z.string(),
      ownerEmail: z.string().nullable(),
      userType: z.enum(UserType),
    }),
  ),
});

export const AdminCloneUserResponseSchema = z.object({
  cloned: z.array(
    z.object({
      id: z.number(),
      slackUserId: z.string(),
      ownerEmail: z.string().nullable(),
      userType: z.enum(UserType),
    }),
  ),
});

export const AdminCloneArtifactsResponseSchema = z.object({
  artifactCount: z.number(),
  executionCount: z.number(),
  blueprintCount: z.number(),
  legacyCount: z.number(),
});
